module.exports = require("@pb/kit-hooks-use-abort-signal");